
const domains = {
    "https://contact.mobile2.global" : process.env.REACT_APP_API_URL,
    "https://test-contact.mobile2.global" : process.env.REACT_APP_TEST_API_URL
}
export const BACKEND_URI = process.env.NODE_ENV === 'development' ? "http://localhost:8000" : domains[window.location.origin]


export const accessTokenKey = "Mobile2CredentialsManager.accessToken"
export const idTokenKey = "Mobile2CredentialsManager.idToken"

export const MAX_FILE_SIZE = 50 * 1024 * 1024; // 50 MB
export const MAX_FILES = 5;

export const languageOptions = {
  'en': {
    code: "en",
    name: "English",
    country_code: "gb",
    icon: process.env.PUBLIC_URL + "/locales/en/icon.png"
  }, 
  'tr': {
    code: "tr",
    name: "Türkçe",
    country_code: "tr",
    icon: process.env.PUBLIC_URL + "/locales/tr/icon.png"
  },
  'de': {
    code: "de",
    name: "Deutsch",
    country_code: "de",
    icon: process.env.PUBLIC_URL + "/locales/de/icon.png"
  },
  'es': {
    code: "es",
    name: "Español",
    country_code: "es",
    icon: process.env.PUBLIC_URL + "/locales/es/icon.png"
  },
  'fr': {
    code: "fr",
    name: "Français",
    country_code: "fr",
    icon: process.env.PUBLIC_URL + "/locales/fr/icon.png"
  },
  'it': {
    code: "it",
    name: "Italiano",
    country_code: "it",
    icon: process.env.PUBLIC_URL + "/locales/it/icon.png"
  },
  'pt-BR': {
    code: "pt-BR",
    name: "Português (Brasil)",
    country_code: "br",
    icon: process.env.PUBLIC_URL + "/locales/pt-BR/icon.png"
  }, 
  'pt': {
    code: "pt",
    name: "Português",
    country_code: "pt",
    icon: process.env.PUBLIC_URL + "/locales/pt/icon.png"
  }, 
  'ru': {
    code: "ru",
    name: "Русский",
    country_code: "ru",
    icon: process.env.PUBLIC_URL + "/locales/ru/icon.png"
  },
  'ar': {
    code: "ar",
    name: "اللغة العربية",
    country_code: "sa",
    icon: process.env.PUBLIC_URL + "/locales/ar/icon.png"
  },
  'zh': {
    code: "zh",
    name: "中文（普通話)",
    country_code: "zh",
    icon: process.env.PUBLIC_URL + "/locales/zh/icon.png"
  },
  'ja': {
    code: "ja",
    name: "日本語",
    country_code: "ja",
    icon: process.env.PUBLIC_URL + "/locales/ja/icon.png"
  },
}

export const devPageIndices = {
  "TICKET ID": "ticket_id",
  CHAT: "chat",
  NAME: "name",
  CHARACTER: "characterName",
  EMAIL: "email",
  SERVER: "server",
  CATEGORY: "categories",
  STATUS: "status",
  PRIORITY: "priority",
  UPDATED: "lastUpdated",
  CREATED: "createdAt",
  ASSIGNED: "assignedTo",
};


export const statusToUserStatus = {
    "NEW TICKET": { title: "ACTIVE", style: "" },
    "REPLIED": { title: "ACTIVE", style: "" },
    "WAITING DEV": { title: "ACTIVE", style: "" },
    "ON HOLD": { title: "ACTIVE", style: "" },
    "CLOSED": { title: "CLOSED", style: "text-red-600 dark:text-red-500" },
    "RESOLVED": { title: "RESOLVED", style: "text-green-600 dark:text-green-500" }
}


export const memberProfileStyles = {
    0: "hover:bg-sky-500 hover:text-black",
    1: "hover:bg-sky-700 hover:text-black",
    2: "hover:bg-purple-500 hover:text-black",
    3: "hover:bg-purple-700 hover:text-black",
}


export const devsTableIndices = {
  "#": "#",
  AVATAR: "avatar",
  NAME: "name",
  EMAIL: "email",
  CATEGORIES: "categories",
  SERVERS: "servers",
  ROLE: "role",
  DISABLED: "disabled",
  "ACTIVE TICKETS": "activeTickets",
  ACTIONS: "actions"
}


export const rowsPerPage = [
  10,
  25,
  50,
  100
]


export const tableSortingEntries = [
  "createdAt",
  null,
  "name",
  "characterName",
  "email",
  null,
  null,
  "status",
  "priority",
  "lastUpdated",
  "createdAt",
  "assignedTo",
]


export const tableDevsSortingEntries = [
  null,
  null,
  "name",
  "email",
  null,
  null,
  "rank",
  null,
  null,
  null
]


export const playerLinks = [
    {
        title: "Search Players",
        link: "search-members",
        permission: "members:view"
      },
      {
        title: "Banned (Support)",
        link: "search-banned",
        permission: "members:view"
      },
    //   {
    //     title: "Banned (Game)",
    //     link: "search-game-banned",
    //     permission: "members:view"
    //   },
]


export const setupLinks = [
  {
    title: "Quick Replies",
    link: "quick-replies",
    permission: "quick_response:view"
  },
  {
    title: "Category Setup",
    link: "category-setup",
    permission: "setup:view"
  },
  {
    title: "Priority Setup",
    link: "priority-setup",
    permission: "setup:view"
  },
  {
    title: "Server Setup",
    link: "server-setup",
    permission: "setup:view"
  },
  {
    title: "Announcements",
    link: "announcements-setup",
    permission: "announcement:view"
  },
  {
    title: "Employee Announcements",
    link: "employee-announcements-setup",
    permission: "announcement:view"
  },
  {
    title: "Excuses Setup",
    link: "excuses-setup",
    permission: "setup:create"
  },
  {
    title: "FAQ Setup",
    link: "faq-setup",
    permission: "faq:create"
  },
]


export const settingsLinks = [
  {
    title: "Profile",
    link: "profile-settings",
    permissions: "profile:view"
  },
  {
    title: "Preferences",
    link: "preference-settings",
    permissions: "profile:view"
  },
]


export const priorityColors = [
  "bg-red-700 text-white",
  "bg-green-700 text-white",
  "bg-stone-800 text-white",
  "bg-yellow-400 text-black",
]


export const serverColors = [
    "bg-red-700 text-white",
    "bg-sky-600 text-white",
    "bg-yellow-600 text-white",
    "bg-teal-600 text-white",
    "bg-fuchsia-600 text-white",
]

export const devRankStyles = {
  admin: "bg-fuchsia-600 text-white",
  mod: "bg-purple-600 text-white",
  dev: "bg-violet-500 text-white",
}


export const categoryColors = [
  "bg-black text-white",
  "bg-orange-950 text-white",
  "bg-sky-950 text-white",
  "bg-red-600 text-white",
  "bg-teal-400 text-black",
  "bg-purple-800 text-white",
  "bg-orange-800 text-white",
  "bg-blue-700 text-white",
  "bg-gray-800 text-white",
]


export const userClasses = {
  user: "",
  dev: ""
}

export const passwordPattern = "(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*_=+-.,]).{8,}"

export const ActionStatus = {
    CREATED : {
        key: "CREATED",
        title: "Oluşturuldu",
        description: "Kullanıcı yeni bir talep oluşturdu",
        inBox: false
    },
    UPDATED : {
        key: "UPDATED",
        title: "Güncellendi",
        description: "Talebin öncelik durumunu / kategorisini değiştirdi",
        inBox: true
    },
    ASSIGNED : {
        key: "ASSIGNED",
        title: "Atadı",
        description: "Talebi başka bir yetkiliye atadı",
        inBox: true
    },
    RESOLVED : {
        key: "RESOLVED",
        title: "Çözüldü",
        description: "Kullanıcı talebi çözdü",
        inBox: true
    },
    CLOSED : {
        key: "CLOSED",
        title: "Kapatıldı",
        description: "Kullanıcı talebi kapattı",
        inBox: true
    },
    REOPENED : {
        key: "REOPENED",
        title: "Yeniden Açıldı",
        description: "Kullanıcı talebi yeniden açtı",
        inBox: true
    },
    ON_HOLD : {
        key: "ON_HOLD",
        title: "Beklemede",
        description: "Kullanıcı talebi beklemeye aldı",
        inBox: true
    },
    BANNED : {
        key: "BANNED",
        title: "Yasaklama",
        description: "Kullanıcı yasaklama işlemi yaptı",
        inBox: true
    },
    UNBANNED : {
        key: "UNBANNED",
        title: "Yasaklama Kaldırıldı",
        description: "Kullanıcı yasaklamayı kaldırdı",
        inBox: true
    },
    WAITING_DEV : {
        key: "WAITING_DEV",
        title: "Yanıt Bekliyor",
        description: "GM'den yanıt bekleniyor",
    },
    REPLIED : {
        key: "REPLIED",
        title: "Yanıtlandı",
        description: "GM tarafından yanıtlandı",
        inBox: true
    },
}